import React,{useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import frame2 from '../assets/Group 22.svg';
import Monetize from '../assets/Desktop - 2.png';
import locationi from '../assets//location.png';

import '../components/css/SectionGrid.css'; // Import 

const FunctionSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      easing: 'ease-in-out', 
      once: false, 
      offset: 100, 
    });
  }, []);
  const features = [
    {
      title: "Connect with Agric Experts",
      description: "Grow your knowledge and skills by networking with agricultural experts and accessing the right guidance and resources.",
      id: "connect",
      image: frame2 
    },
    {
      title: "Sell Your Produce Online",
      description: "Market your harvest directly to customers from the comfort of your home",
      id: "sell",
      image: frame2
    },
    {
      title: "Track Farm Progress",
      description: "Monitor growth, yields, and performance with detailed periodic insights",
      id: "track",
      image: frame2
    },
    {
      title: "Turn your produce into income",
      description: " Easily manage your sales and payments with our integrated tools",
      id: "income",
      image: Monetize
    },
    {
     title: "Connect with Agric Experts",
      description: "Grow your knowledge and skills by networking with agricultural experts and accessing the right guidance and resources.",
      id: "Location",
      className: "inventory-style",
      image :locationi
    },
  ];

  return (
    <section className="feature-section">
       <div className="top-section">
            <div className="left-section-g">
                <span>
                    <i className='fas fa-user'></i>
                    <p>Welcom to Agricverse</p>
                </span>
                <h1>
                    Built For Agricultural Success
                </h1>
                <p>Smart tools and insights to help you farm better and grow more.</p>
            </div>
   
        </div>


      <div className="bottom-features">
        {features.slice(2, 5).map((feature) => (
          <div className="feature-card small" key={feature.id} data-aos="fade-up">
            <div className="feature-content">
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
            <div className="feature-image" id={`image-${feature.id}`}>
              {feature.image && (
                <img aos data-aos="fade-up"
                  className={feature.className }
                 
                  src={feature.image}
                  alt={feature.title}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FunctionSection;